var map = {
	"./IOT1.png": "8c39",
	"./IOT2.png": "b9bc",
	"./IOTfeiqi.png": "e104",
	"./ac.png": "bbf8",
	"./account1.png": "a20b",
	"./account2.png": "dc33",
	"./accountfeiqi.png": "9ef4",
	"./advertising1.png": "2297",
	"./advertising2.png": "689a",
	"./appstoreAdd.png": "621d",
	"./back.png": "92ed",
	"./battery.png": "c83d",
	"./buildingNav1.png": "ea77",
	"./buildingNav2.png": "5110",
	"./buildingNavfeiqi.png": "f634",
	"./dateImg.png": "0c36",
	"./dateReportNav.png": "3130",
	"./disinfectNav1.png": "c7e2",
	"./disinfectNav2.png": "bc09",
	"./disinfectNavfeiqi.png": "9ec0",
	"./disinfectionNav.png": "526b",
	"./dispatchernav1.png": "b0ac",
	"./dispatchernav2.png": "012d",
	"./edition.png": "94bb",
	"./endnew.png": "4163",
	"./eq.png": "ec26",
	"./finishnew.png": "be87",
	"./homes1.png": "05ca",
	"./homes2.png": "0394",
	"./logo.png": "266c",
	"./messages.png": "a975",
	"./network.png": "e880",
	"./noMap.png": "21c2",
	"./nodata.png": "4784",
	"./nodataArea.png": "6a60",
	"./offlineImg.png": "7074",
	"./offlineImg0.png": "d8d1",
	"./onlineImg.png": "6b81",
	"./purchases.png": "70c7",
	"./regionNav.png": "a475",
	"./robot.png": "6e5f",
	"./robotImg.png": "3f15",
	"./robotImg1.png": "8238",
	"./robotImg2.png": "cd9b",
	"./robotImg3.png": "b467",
	"./robotImg4.png": "48bc",
	"./robotImgSelected.png": "5617",
	"./robotNav1.png": "7a33",
	"./robotNav2.png": "8f90",
	"./robotNavfeiqi.png": "f453",
	"./shoppings.png": "1748",
	"./systemNav.png": "3022",
	"./task.png": "5188",
	"./time.png": "a579",
	"./user.png": "7026",
	"./userImg.png": "1274",
	"./visits.png": "01be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a53";